(() => {
  if (window.ncGalleryKeyboardReady) return;
  window.ncGalleryKeyboardReady = true;
  const sync = list => {
    const tabs = [...list.querySelectorAll('[role="tab"]')];
    tabs.forEach(tab => { const value = tab.getAttribute('aria-selected') === 'true' ? 0 : -1; if (tab.tabIndex !== value) tab.tabIndex = value; });
  };
  const init = () => document.querySelectorAll('slideshow-controls [role="tablist"]').forEach((list, groupIndex) => {
    if (list.dataset.ncKeyboardReady) return;
    list.dataset.ncKeyboardReady = 'true';
    const slides = [...(list.closest('slideshow-component')?.querySelectorAll('slideshow-slide') || [])];
    [...list.querySelectorAll('[role="tab"]')].forEach((tab, index) => {
      if (!slides[index]) return;
      tab.id ||= `nc-gallery-${groupIndex}-tab-${index}`;
      slides[index].id ||= `nc-gallery-${groupIndex}-panel-${index}`;
      tab.setAttribute('aria-controls', slides[index].id);
      slides[index].setAttribute('role', 'tabpanel');
      slides[index].setAttribute('aria-labelledby', tab.id);
    });
    sync(list);
    new MutationObserver(() => sync(list)).observe(list, {subtree:true, attributes:true, attributeFilter:['aria-selected']});
    list.addEventListener('keydown', event => {
      const tab = event.target.closest('[role="tab"]');
      if (!tab || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
      event.preventDefault();
      const tabs = [...list.querySelectorAll('[role="tab"]')];
      const position = tabs.indexOf(tab);
      const index = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (position + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
      tabs[index].focus();
      tabs[index].click();
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
  document.addEventListener('shopify:section:load', init);
})();
/* Restore focus after the native drawer finishes closing, without changing its close behavior. */
document.addEventListener('keydown', event => {
  if (event.key !== 'Escape' || !(event.target instanceof Element)) return;
  const drawer = event.target.closest('header-drawer');
  const details = event.target.closest('details') || drawer?.querySelector('details[open]');
  const summary = details?.querySelector('summary');
  if (!drawer || !details?.open || !summary) return;
  const observer = new MutationObserver(() => {
    if (details.open) return;
    observer.disconnect();
    summary.focus();
  });
  observer.observe(details, {attributes:true,attributeFilter:['open']});
}, true);
/* Keep native filter submission; bridge keyboard activation across the nested floating panel. */
document.addEventListener('keydown', event => {
  if (!(event.target instanceof Element)) return;
  const option = event.target.closest('sorting-filter-component [role="option"]');
  const component = event.target.closest('sorting-filter-component');
  const summary = event.target.closest('summary');
  if ((!option && !summary) || !component || !['Enter',' ','ArrowDown','ArrowUp','Home','End'].includes(event.key)) return;
  if (summary && ['Enter',' '].includes(event.key)) return;
  event.preventDefault();
  event.stopPropagation();
  if (summary) summary.closest('details').open = true;
  if (event.key === 'Enter' || event.key === ' ') { option.querySelector('input[type="radio"]')?.click(); return; }
  const options = [...component.querySelectorAll('[role="option"]')];
  const index = option ? options.indexOf(option) : options.findIndex(element => element.getAttribute('aria-selected') === 'true');
  const next = event.key === 'Home' ? 0 : event.key === 'End' ? options.length - 1 : Math.max(0, Math.min(options.length - 1, index + (event.key === 'ArrowDown' ? 1 : -1)));
  options.forEach((element, i) => {element.tabIndex = i === next ? 0 : -1;});
  options[next].focus();
}, true);
